<template>
  <div>
    <FixedButton class="myFixedBtn">
      <el-button type="primary" @click.stop="add" size="small">新建</el-button>
    </FixedButton>
    <CardContainer>
      <div slot="header">
        <CommonForm @search="formSearch" :form-json="formjson" />
      </div>
      <CommonTable
        width="170"
        ref="table"
        :needIndex="true"
        :data="tableData"
        :total="total"
        @change="handleTableChange"
        :operation="operation"
        @operation="handleOperation"
        :table-json="tablejson"
      >
      </CommonTable>
    </CardContainer>
    <Dialog :row="row" v-if="visible" @refresh="formSearch" :visible.sync="visible" />
  </div>
</template>

<script>
import formjson from './Model/Formjson.Wine'
import tablejson from './Model/Tablejson.Wine'
import formTableMixin from '@manage/mixins/formTableMixin'
import Dialog from './WineDialog'
export default {
  mixins: [formTableMixin],
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        {
          name: '编辑',
          type: 'edit'
        },
        {
          name: '删除',
          type: 'delete'
        }
      ],
      row: {},
      visible: false,
      queryApi: this.$api.basicdata.device_type_list,
      deleteApi: this.$api.basicdata.device_type_delete
    }
  },
  components: {
    Dialog
  },
  methods: {
    formSearch(data, pageObj) {
      if (!data) {
        data = this.cacheData
      }
      data.devType = '02' // 01厨冷 02红酒
      this.search(data, pageObj, this.queryApi)
    },
    add() {
      this.row = {}
      this.visible = true
    },
    handleEdit(row) {
      this.row = row
      this.visible = true
    },
    handleDelete(row) {
      this.$confirm(`确认删除该设备型号吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.deleteApi, params)
            .then(() => {
              this.$message.success('设备型号删除成功')
              this.formSearch(this.cacheData, this.cachePage)
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'edit':
          this.handleEdit(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
      }
    }
  }
}
</script>

<style lang="less">
.myFixedBtn {
  right: 24px !important;
  top: 40px !important;
  z-index: 2;
}
</style>
